/**
 * Category Filter Component
 * Dropdown filter for provider categories
 */

import {
  SelectRoot,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/Select';
import { CategoryIcon } from './CategoryIcon';
import { useProviderCategories, CategoryWithCount } from '../../hooks/useProviderCategories';
import { Loader2 } from 'lucide-react';

interface CategoryFilterProps {
  value: string;
  onChange: (value: string) => void;
  includeEmpty?: boolean;
  placeholder?: string;
  className?: string;
}

export function CategoryFilter({
  value,
  onChange,
  includeEmpty = false,
  placeholder = 'Filtrar por categoria',
  className,
}: CategoryFilterProps) {
  const { data: categories, isLoading } = useProviderCategories(includeEmpty);

  if (isLoading) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <Loader2 className="h-4 w-4 animate-spin" />
        <span className="text-sm text-muted-foreground">Carregando categorias...</span>
      </div>
    );
  }

  return (
    <SelectRoot value={value} onValueChange={onChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="ALL">
          <div className="flex items-center gap-2">
            <span>Todas as Categorias</span>
          </div>
        </SelectItem>
        {categories?.map((cat: CategoryWithCount) => (
          <SelectItem key={cat.code} value={cat.code}>
            <div className="flex items-center gap-2">
              <CategoryIcon iconName={cat.icon} size={14} />
              <span>{cat.displayName}</span>
              <span className="text-muted-foreground">({cat.templateCount})</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </SelectRoot>
  );
}

export default CategoryFilter;
